module.exports = __webpack_public_path__ + "static/media/thunderstorm.a8941e30.jpeg";